module.exports = __webpack_public_path__ + "files/971166f3590046e57392048d16a51e40.png";